module.exports = __webpack_public_path__ + "media/assets/icons/envelope-21bb8649faf70af52f93b2e5ddbbc58a.svg";